import { ApiError } from './api-error';

/**
 * Turns any thrown value into something safe to show a user.
 *
 * `ApiError` messages come from the server's own catalogue and are already
 * written for display. Anything else is a bug, a network fault or a parse
 * failure, and its message could contain internals, so it is replaced.
 */
export function toDisplayMessage(error: unknown, fallback = 'Something went wrong.'): string {
  if (error instanceof ApiError) {
    return error.message;
  }

  return fallback;
}

/**
 * Field-level validation messages, keyed by field name.
 *
 * Lets a form put "must contain a digit" beside the password box instead of
 * dumping a list at the top.
 */
export function toFieldErrors(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError)) {
    return {};
  }

  const fields: Record<string, string> = {};

  for (const detail of error.details) {
    if (detail.field === undefined) {
      continue;
    }

    // Several rules can fail at once; joining keeps them all visible rather
    // than showing whichever happened to be last.
    fields[detail.field] =
      fields[detail.field] === undefined
        ? detail.message
        : `${fields[detail.field]} ${detail.message}`;
  }

  return fields;
}
